<template>
  <v-container fluid>

    <v-row>
      <v-col cols="6">
        <QTextField v-model="item.ProjectNumber" :label="$t('servicesystem.common_objects.project.project_number')"
           clearable :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col cols="6">
        <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.project.name')"
           clearable :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <CustomerSelect v-model="item.CustomerId" clearable :externaledit="editMode" @FocusState="handleFocus">
        </CustomerSelect>
      </v-col>
        <v-col cols="6">
        <QTextField v-model="item.State" :label="$t('servicesystem.common_objects.project.state')"
           clearable :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <QTextField v-model="startdate"  type="date" :label="$t('servicesystem.common_objects.project.start')"
           clearable :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col cols="6">
        <QTextField v-model="enddate"  type="date" :label="$t('servicesystem.common_objects.project.end')"
           clearable :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>

  </v-container>
</template>


<script>
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";

export default {
  name: "ProjectEditContent",
  props: {
    item: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    CustomerSelect,
  },
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
  },

  computed: {
    startdate: {
      get() {
        return this.VuetifyFormatDate(this.item.StartDate);
      },
      set(value) {
        this.item.StartDate = value;
      },
    },

    enddate: {
      get() {
        return this.VuetifyFormatDate(this.item.EndDate);
      },
      set(value) {
        this.item.EndDate = value;
      },
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>